module.exports = __webpack_public_path__ + "img/physician-logs.3bc9f52f.png";